import { BaseBillingEntity } from '/@/modules/billing/models/BaseBillingEntity';
import NumeralService from '/@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '/@/modules/core/app/constants/data.constants';
import { BillingPlanType } from '/@/modules/billing/constants/BillingPlanType';
import { BillingPlanMapping } from '/@/modules/billing/models/BillingPlanMapping';

export class BillingPlan extends BaseBillingEntity {
  /**
   * @var {string}
   */
  addonApplicability;

  /**
   * @var {number}
   */
  billedPrice;

  /**
   * @var {string}
   */
  chargeModel;

  /**
   * @var {string}
   */
  currencyCode;

  /**
   * @var {string}
   */
  description;

  /**
   * @var {boolean}
   */
  enabledInHostedPages;

  /**
   * @var {boolean}
   */
  enabledInPortal;

  /**
   * @var {number}
   */
  freeQuantity;

  /**
   * @var {boolean}
   */
  giftable;

  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  invoiceName;

  /**
   * @var {boolean}
   */
  isShippable;

  /**
   * @var {object}
   */
  metaData;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  object;

  /**
   * @var {number}
   */
  period;

  /**
   * @var {string}
   */
  periodUnit;

  /**
   * @var {number}
   */
  price;

  /**
   * @var {number}
   */
  pricingModel;

  /**
   * @var {boolean}
   */
  showDescriptionInInvoices;

  /**
   * @var {boolean}
   */
  showDescriptionInQuotes;

  /**
   * @var {string}
   */
  status;

  /**
   * @var {boolean}
   */
  taxable;

  /**
   * @var {array}
   */
  tiers;

  constructor(model = {}) {
    super(model);

    this.addonApplicability = model.addonApplicability;
    this.billedPrice = model.billedPrice;
    this.chargeModel = model.chargeModel;
    this.currencyCode = model.currencyCode;
    this.description = model.description;
    this.enabledInHostedPages = model.enabledInHostedPages;
    this.enabledInPortal = model.enabledInPortal;
    this.freeQuantity = model.freeQuantity;
    this.giftable = model.giftable;
    this.id = model.id;
    this.invoiceName = model.invoiceName;
    this.isShippable = model.isShippable;
    this.metaData = model.metaData;
    this.name = model.name;
    this.object = model.object;
    this.period = model.period;
    this.periodUnit = model.periodUnit;
    this.price = model.price;
    this.pricingModel = model.pricingModel;
    this.showDescriptionInInvoices = model.showDescriptionInInvoices;
    this.showDescriptionInQuotes = model.showDescriptionInQuotes;
    this.status = model.status;
    this.taxable = model.taxable;
    this.tiers = model.tiers;
    // This mapping is an exception since BillingPlan is not a DB entity
    // and the risk of circular dependency is non existent
    this.mapping = BillingPlanMapping.mapModelOrNull(model.mapping);
  }

  /**
   * @returns {string}
   */
  get priceFormatted() {
    return NumeralService.formatValue(this.billedPrice, ColumnFormat.FORMAT_CURRENCY);
  }

  /**
   * @returns {boolean}
   */
  get isRecommended() {
    return this.mapping?.isRecommended;
  }

  /**
   * @returns {boolean}
   */
  get isBest() {
    return this.mapping.type === BillingPlanType.BEST;
  }
}
